export const baseUrlAPI = 'https://dormakaba-claim.ru/app/api/';
export const baseUrl = 'https://dormakaba-claim.ru/app/';
//# sourceMappingURL=globals.js.map